var _slicedToArray = require("/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/slicedToArray.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var v = Object.create;
var l = Object.defineProperty;
var k = Object.getOwnPropertyDescriptor;
var w = Object.getOwnPropertyNames;
var C = Object.getPrototypeOf,
  P = Object.prototype.hasOwnProperty;
var b = function b(e, r) {
    for (var o in r) l(e, o, {
      get: r[o],
      enumerable: !0
    });
  },
  c = function c(e, r, o, n) {
    if (r && typeof r == "object" || typeof r == "function") {
      var _iterator = _createForOfIteratorHelper(w(r)),
        _step;
      try {
        var _loop = function _loop() {
          var h = _step.value;
          !P.call(e, h) && h !== o && l(e, h, {
            get: function get() {
              return r[h];
            },
            enumerable: !(n = k(r, h)) || n.enumerable
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  };
var N = function N(e, r, o) {
    return o = e != null ? v(C(e)) : {}, c(r || !e || !e.__esModule ? l(o, "default", {
      value: e,
      enumerable: !0
    }) : o, e);
  },
  E = function E(e) {
    return c(l({}, "__esModule", {
      value: !0
    }), e);
  };
var S = {};
b(S, {
  ThemeProvider: function ThemeProvider() {
    return f;
  },
  Toggle: function Toggle() {
    return g;
  },
  useTheme: function useTheme() {
    return s;
  }
});
module.exports = E(S);
var d = require("react");
var T = N(require("react")),
  a = T.default.createContext({
    theme: "dark",
    setTheme: function setTheme() {},
    options: {
      theme: "dark",
      save: !0
    }
  });
function s() {
  return (0, d.useContext)(a);
}
var t = require("react/jsx-runtime");
function g(_ref) {
  var _ref$id = _ref.id,
    e = _ref$id === void 0 ? "rth-toggle" : _ref$id;
  var _s = s(),
    r = _s.theme,
    o = _s.setTheme;
  return (0, t.jsxs)("div", {
    className: "rht-toggle",
    children: [(0, t.jsx)("input", {
      id: e,
      className: "rht-switch",
      type: "checkbox",
      role: "switch",
      onChange: function onChange(h) {
        return o(h.target.checked ? "dark" : "light");
      },
      checked: r === "dark"
    }), (0, t.jsxs)("label", {
      className: "rht-label",
      htmlFor: e,
      children: [(0, t.jsx)("svg", {
        className: "rht-moon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: (0, t.jsx)("path", {
          d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        })
      }), (0, t.jsxs)("svg", {
        className: "rht-sun",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [(0, t.jsx)("circle", {
          cx: "12",
          cy: "12",
          r: "5"
        }), (0, t.jsx)("line", {
          x1: "12",
          y1: "1",
          x2: "12",
          y2: "3"
        }), (0, t.jsx)("line", {
          x1: "12",
          y1: "21",
          x2: "12",
          y2: "23"
        }), (0, t.jsx)("line", {
          x1: "4.22",
          y1: "4.22",
          x2: "5.64",
          y2: "5.64"
        }), (0, t.jsx)("line", {
          x1: "18.36",
          y1: "18.36",
          x2: "19.78",
          y2: "19.78"
        }), (0, t.jsx)("line", {
          x1: "1",
          y1: "12",
          x2: "3",
          y2: "12"
        }), (0, t.jsx)("line", {
          x1: "21",
          y1: "12",
          x2: "23",
          y2: "12"
        }), (0, t.jsx)("line", {
          x1: "4.22",
          y1: "19.78",
          x2: "5.64",
          y2: "18.36"
        }), (0, t.jsx)("line", {
          x1: "18.36",
          y1: "5.64",
          x2: "19.78",
          y2: "4.22"
        })]
      }), (0, t.jsx)("span", {
        className: "rht-ball"
      })]
    })]
  });
}
var m = require("react");
function p(e) {
  localStorage.setItem("rht-theme", e);
}
function x() {
  return localStorage.getItem("rht-theme");
}
function u() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
var y = require("react/jsx-runtime"),
  L = "dark";
function f(_ref2) {
  var _ref2$options = _ref2.options,
    e = _ref2$options === void 0 ? {} : _ref2$options,
    r = _ref2.children;
  var _ref3 = (0, m.useState)(L),
    _ref4 = _slicedToArray(_ref3, 2),
    o = _ref4[0],
    n = _ref4[1];
  (0, m.useEffect)(function () {
    var i = x() || u() || (e == null ? void 0 : e.theme);
    n(i);
  }, []), (0, m.useEffect)(function () {
    document.body.setAttribute("data-theme", o);
  }, [o]);
  var h = (0, m.useCallback)(function (i) {
    e != null && e.save && p(i), n(i);
  }, []);
  return (0, y.jsx)(a.Provider, {
    value: {
      theme: o,
      setTheme: h,
      options: e
    },
    children: r
  });
}